import apiClient from "../lib/apiClient";
import { getConfiguredSchoolId } from "./schoolConfig";

// ================= SUBJECT =================
export const getSubjects = async () => {
  const res = await apiClient.get("/api/subjects");
  return res.data;
};

// ================= CHAPTER =================
export const getChapterTopic = async (payload) => {
  // Previous all-school endpoint:
  // const res = await apiClient.post("/Panel/GetChapterTopic", {
  //   classid: Number(payload.classId),
  //   subjectid: Number(payload.subjectId),
  // });

  const res = await apiClient.post("/Panel/GetChapterTopic", {
    classid: Number(payload.classId),
    subjectid: Number(payload.subjectId),
  });

  return res.data;
};

// ================= SCHOOL-WISE CHAPTER/TOPIC =================
export const getChapterTopicBySchool = async (payload) => {
  const schoolId = payload.schoolId || await getConfiguredSchoolId();

  const res = await apiClient.post(
    "/Panel/GetChapterTopic1",
    {
      classid: Number(payload.classId),
      subjectid: Number(payload.subjectId),
      schoolid: Number(schoolId),
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  return res.data;
};

//=======================GetTopicByChapterId=================
export const getTopicsByChapter = async (chapterId) => {
  const res= await apiClient.post("/Topics/GetTopicsByChapterID",
  {
      id: chapterId,
    })
     return res.data;
  }

// ================= Get PAST SESSIONS userid class subject chapter topic  id =================
export const getFilteredSessions = async (filters, userId, schoolId) => {
  const payload = {
    userUniuqeId: 
    Number(userId),
    schoolId: Number(schoolId) || 0,
    classId:
     Number(filters.classId),
    subjectId: Number(filters.subject) || 0,
    sectionId: 36, // dynamic if needed
     chapterId:Number(filters.chapter) || 0,
    topicId: Number(filters.topic) || 0,
     date: filters.date || null,
  };

  const res = await apiClient.post(
    "/LiveClasses/GetAllLiveClasses",
    payload
  );
  console.log("Test user response =",res)

  return res.data;
};

//===============Get content by topic id ==================
export const getContentsByTopicID = async (topicId) => {
    try {
        const res = await apiClient.post(
            `/Contents/GetContentsByTopicID`,
            {
                ID: topicId
            }
        );

        return res.data;
    } catch (err) {
        console.error(err);
        return [];
    }
};

//==============Save Attendance===================
export const markAttendance = async (payload) => {

  const response = await apiClient.post(
    "/LiveClasses/MarkAttendance",
    payload,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return response.data;
};

//================Add usage content Report ===============

export const addContentUsageLog = async (payload) => {
  const response = await apiClient.post(
    "/log/AddContentUsageLog",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
